import { render, staticRenderFns } from "./PatientTxPlansModal.vue?vue&type=template&id=f1d8c5aa&scoped=true"
import script from "./PatientTxPlansModal.vue?vue&type=script&lang=js"
export * from "./PatientTxPlansModal.vue?vue&type=script&lang=js"
import style0 from "./PatientTxPlansModal.vue?vue&type=style&index=0&id=f1d8c5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d8c5aa",
  null
  
)

export default component.exports